import dome1 from "../../assets/images/rentals/dome1.avif";
import dome2 from "../../assets/images/rentals/dome2.avif";
import dome3 from "../../assets/images/rentals/dome3.avif";
import dome4 from "../../assets/images/rentals/dome4.avif";
import dome5 from "../../assets/images/rentals/dome5.avif";
import dome6 from "../../assets/images/rentals/dome6.avif";
import dome7 from "../../assets/images/rentals/dome7.avif";

import yurt1 from "../../assets/images/rentals/yurt1.jpg";
import yurt2 from "../../assets/images/rentals/yurt2.webp";
import yurt3 from "../../assets/images/rentals/yurt3.jpg";
import yurt4 from "../../assets/images/rentals/yurt4.webp";

import bus1 from "../../assets/images/rentals/bus1.jpg";
import bus2 from "../../assets/images/rentals/bus2.jpg";
import bus3 from "../../assets/images/rentals/bus3.jpg";
import bus4 from "../../assets/images/rentals/bus4.jpg";

import cabin1 from "../../assets/images/rentals/cabin1.jpg";
import cabin2 from "../../assets/images/rentals/cabin2.jpg";
import cabin3 from "../../assets/images/rentals/cabin3.jpg";
import cabin4 from "../../assets/images/rentals/cabin4.jpg";

export const domeImages = [dome1, dome2, dome3, dome4, dome5, dome6, dome7];
export const yurtImages = [yurt1, yurt2, yurt3, yurt4];
export const busImages = [bus1, bus2, bus3, bus4];
export const cabinImages = [cabin1, cabin2, cabin3, cabin4];
